<template>
    <modal
      name="collection-video-preview" :click-to-close="true" @before-open="modalBeforeOpen" @closed="modalClosed">
      <div class="modal show modal__collection_video_preview modal__new_design">
        <section>
          <a class="modal__close">
            <i class="icon-close" @click="hide" />
          </a>
  
          <div class="modal__body">
            <VideoContent
              v-if="previewVideoCard"
              :content="previewVideoCard"
              class="full__width" />
          </div>
        </section>
      </div>
    </modal>
  </template>
  
  <script>
  import VideoContent from '@components/Card/VideoContent.vue'; 
  
  export default {
    name: 'CollectionVideoPreview',
    components: {
      VideoContent,
    },
    data() {
      return {
        previewVideoCard: null, 
      };
    },
    // mounted() {
    //     // const that = this
    //     window.addEventListener('click-preview-video-btn', async (e) => {
    //       console.log('Inside vue modal event listener');
    //       console.log(this.previewVideoCard)
    //       this.$modal.show('collection-video-preview', { ...this.previewVideoCard });
    //     })
    // },
    mounted() {
      window.addEventListener('click-preview-video-btn', this.handlePreviewVideoClick);
    },
    methods: {
      handlePreviewVideoClick() {
        console.log('Inside vue modal event listener'); // Check if this logs
        console.log(this.previewVideoCard); // Check if this logs
        this.$modal.show('collection-video-preview', { ...this.previewVideoCard });
      },
      hide() {
        this.$modal.hide('collection-video-preview');
      },
      modalBeforeOpen(event) {
        const { params } = { ...event };
        const { previewVideoCard } = { ...params };
        if (previewVideoCard) {
          this.previewVideoCard = previewVideoCard;
        }
      },
      modalClosed() {
        this.previewVideoCard = null; 
      },
    },
  };
  </script>
  
<style scoped>
    .modal__collection_video_preview {
        border-radius: 8px;
        padding: 20px;

        section {
            width: 1400px;
            padding: 35px;
        }
    
        .modal__close {
            position: absolute;
            top: 14px;
            right: 14px;
            cursor: pointer;
        }
    
        .modal__body {
            margin-top: 20px;
        }
    }  
</style>